/**
 * Constantes para valores en celdad de las tablas
 */
export const CELL_CONSTANTS = {
    /**
     * Texto que indica que el valor no aplica
     */
    NO_APLICA: 'NO APLICA'
}
/**
 * Tipos de Garantia
 */
export const GARANTIA_ROL = {
    /**
     * 104 - REVISOR_TESORERIA
     */
    REVISOR_TESORERIA: "109",
    /**
     * 103 - REVISOR_COBRANZA
     */
    REVISOR_COBRANZA: "108",
    /**
     * 114 - LOCATARIO_FINANCIERO
     */
    LOCATARIO_FINANCIERO: "114",
    /**
     * 111 - REVISOR_COMERCIAL
     */
    REVISOR_COMERCIAL: "111",
    /**
     * 103 - SUPER_ADMIN
     */
    SUPER_ADMIN: "103",

}

/**
 * Tipos de Garantia
 */
export const GARANTIA_TIPO = {
    /**
     * GAR0 - Garantia en efectivo
     */
    GAR0_EFECTIVO: "GAR0",
    /**
     * GAR1 - Garantia en Carta Fianza
     */
    GAR1_CARTA_FIANZA: "GAR1",

    /**
     * GAR1 - Sin  Garantia
     */
    GAR2_SIN_GARANTIA: "GAR2"
}


/**
 * Estado de Garantia
 * @readonly
 * @enum(string)
 */
export const GARANTIA_ESTADO = {
    /**
     * En proceso de revisión por parte de los aprobadores.
     */
    EN_REVISION: "ENV",
    /**
     * Registrado desde el proceso de envio desde SAP.
     */
    INGRESADO: "NEW",
    /**
     * En proceso de actualización por parte del Locatario.
     */
    PENDIENTE: "PEN",
    /**
     * Observado por los aprobadores. En proceso de corrección por parte del Locatario.
     */
    OBSERVADO: "OBS",
    /**
     * Rechazado por los aprobadores. En proceso de corrección por parte del Locatario.
     */
    RECHAZADO: "REC",
    /**
     * Aprobado y Validado por los aprobadores.
     */
    APROBADO: "IOK",
    /**
     * Se encuentra en proceso de Requerimiento
     */
    EN_REQUERIMIENTO: "REQ",

    /**
     * Se encuentra en proceso de Requerimiento y Renovacion
     */
    EN_REQUERIMIENTO_RENOVACION: "RRE",
    /**
     * Registrado desde el proceso de Ingresado por Renovacion
     */
    INGRESADO_RENOVACION: "NRE",
}

export const REQUERIMIENTO_SIGNATURE_TYPE = {
    VIRTUAL: {
        CODE: 0,
        TEXT: "Firma Virtual"
    },
    FISICAL: {
        CODE: 1,
        TEXT: "Firma Fisica"
    },
}

export const BANK = {
    BCP: "BCP",
    BBVA: "BBVA",
    GNB: "GNB",
    CITIBANK: "Citibank",
    SANTANDER: "Santander",
    PICHINCHA: "Pichincha",
    SCOTIABANK: "Scotiabank",
    INTERBANK: "Interbank"
}

export const GARANTIA_REQUERIMIENTO_FIRMA_VIRTUAL_TEXT_MODAL = {
    BUTTON: "Enviar a Notaria",
    MODAL_TITLE: {
        BEFORE: "Enviar Carta Notarial a la Notaria",
        DURING: "Enviando Carta Notarial a la Notaria",
        AFTER: "Se envio Carta Notarial a la Notaria",
        ERROR: "No se pudo enviar la Carta Notarial contacte al administrador",
        BUTTON: "Enviar"
    }
}
export const GARANTIA_REQUERIMIENTO_FIRMA_FISICA_TEXT_MODAL = {
    BUTTON: "Generar Carta",
    MODAL_TITLE: {
        BEFORE: "Generar Carta Notarial del requerimiento",
        DURING: "Generando Carta Notarial del requerimiento",
        AFTER: "Se genero Carta Notarial del Requerimiento",
        ERROR: "No se pudo generar la Carta Notarial del Requerimeinto contacte al administrador",
        BUTTON: "Generar"
    }
}
export const GARANTIA_REQUERIMIENTO_FIRMA_BCP_TEXT_MODAL = {
    BUTTON: "Enviar Correo",
    MODAL_TITLE: {
        BEFORE: "Enviar Carta Notarial por correo",
        DURING: "Enviando Carta Notarial por correo",
        AFTER: "Se envio la Carta Notarial por correo",
        ERROR: "No se pudo enviar la Carta Notaria contacte al administrador",
        BUTTON: "Enviar"
    }
}

/**
 * Estado de Excepcion Garantia
 * @readonly
 * @enum(string)
 */
export const EXCEPCION_GARANTIA_ESTADO = {
    /**
    * Pendiente.
    */
    INGRESADO: {
        CODE: "ING",
    },
    /**
     * Pendiente.
     */
    PENDIENTE: {
        CODE: "PEN",
    },
    /**
     * Aprobado.
     */
    APROBADO: {
        CODE: "APR",
    },
    /**
     * Rechazado
     */
    RECHAZADO: {
        CODE: "REC",
    },
}

/**
 * Estado de Excepcion Garantia
 * @readonly
 * @enum(string)
 */
export const EXCEPCION_GARANTIA_ESTADO_COLOR = {
    /**
     * Pendiente.
     */
    PEN: "#CBCBCB",
    /**
     * Aprobado.
     */
    APR: "green",
    /**
     * Rechazado
     */
    REC: "red",
}

/**
 * TIPO de Excepcion Garantia
 * @readonly
 * @enum(string)
 */
export const EXCEPCION_GARANTIA_TIPO = {
    /**
     * Pendiente.
     */
    EFECTIVO_A_CARTA_FIANZA: "ECF",
    /**
     * Aprobado.
     */
    CARTA_FIANZA_A_EFECTIVO: "CFE",
}